export const DON_HANG_MUA_TRONG_NUOC_STATUS_MAP: Record<string, string> = {
  '0': 'Lập chứng từ',
  '1': 'Chờ duyệt',
  '4': 'Đang duyệt',
  '5': 'Đã duyệt',
  '6': 'Đang thực hiện',
  '7': 'Hoàn thành',
  '9': 'Đóng'
};

export const DON_HANG_MUA_TRONG_NUOC_EXPORT_TITLE = 'ĐƠN HÀNG MUA TRONG NƯỚC';
export const DON_HANG_MUA_TRONG_NUOC_SHEET_NAME = 'DonHangMuaTrongNuoc';
export const DON_HANG_MUA_TRONG_NUOC_FILE_NAME = 'Đơn hàng mua trong nước';
